import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import AOS from 'aos';
import { UtilService } from 'src/app/shared/services/util.service';
import { WebserviceService } from 'src/app/shared/services/webservice.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-presentation12',
  templateUrl: './presentation12.component.html',
  styleUrls: ['./presentation12.component.scss'],
})
export class Presentation12Component implements OnInit {
  cloudFrontUrl = environment.cloudFrontUrl;
  myLinksS3URL = environment.myLinksS3URL;
  registerForm!: FormGroup;
  referralId!: string;
  pwdToggle = false;
  userName!: string;
  userDetails: any = {};
  countriesList: any[] = [];
  city!: string;
  country!: string;

  constructor(
    private _service: WebserviceService,
    private aRoute: ActivatedRoute,
    private utilService: UtilService,
    private router: Router
  ) {
    [
      this.userDetails,
      this.userName,
      this.country,
      this.city,
      this.countriesList,
      this.referralId,
    ] = [...this.utilService.getUserDetaisForMyLinksSection(this.aRoute)];
  }

  gotoRegistration() {
    this.router.navigate([], {
      fragment: 'reg_form',
      queryParamsHandling: 'merge',
    });
  }

  ngOnInit(): void {
    AOS.init();
    this.registerForm = this.utilService.getRegisterForm();
  }

  get f() {
    return this.registerForm.controls;
  }

  submitRegister() {
    this._service.doRegistrationForPresentationLinks(
      this.registerForm,
      this.userDetails.userId,
      this.referralId
    );
  }
}
